module.exports = __webpack_public_path__ + "img/tooltip_02-vallone-litho-limestone-oyster-02.03986080.jpg";